import { Component, Input } from '@angular/core';
import { ProgressBarComponent } from '@progress/kendo-angular-progressbar';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'bizz-checklist-progressbar',
  standalone: true,
  imports: [ProgressBarComponent, CommonModule],
  templateUrl: './progressbar.component.html',
  styleUrl: './progressbar.component.scss'
})
export class ChecklistProgressbarComponent {
  @Input() public totalQuestions: number = 0;
  @Input() public checkedQuestions: number = 0;
  @Input() public isMobileView: boolean = false;

}
